import { useQuery } from '@tanstack/react-query';
import { CASE_QUESTIONNAIRES_KEY } from '../../utils/constants/queryKeys';
import { getCaseQuestionnaires } from '../services/fn-api/Questionnaires';

export const useGetCaseQuestionnaires = (caseId: number) => {
  return useQuery({
    queryKey: [CASE_QUESTIONNAIRES_KEY, caseId],
    queryFn: () => getCaseQuestionnaires(caseId),
    enabled: !!caseId,
  });
};
